import React from 'react'
import './Sucursales.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import SucursalesData from '../../Components/Admin/SucursalesData/SucursalesData'

export default function Sucursales() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <SucursalesData />
                </div>
            </section>
        </div>
    )
}



